<template>
    <v-menu
      light
      ref="menu"
      v-model="field.menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      menu-props="light"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          color="info"
          v-model="newValue"
          prepend-icon="palette"
          :rules="field.rules"
          :hint="field.helpText"
          readonly
          v-on="on"
          background-color="secondary"
          :label="field.label"
        >
        </v-text-field>
      </template>
      

      <v-color-picker 
        v-if="showColorPicker"
        v-bind="currentProperties()"
        mode="hexa"
        v-model="newValue"
        >
      </v-color-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'ColorPicker',
  props: [
    'field', 'value'
  ],
  data: function () {
    return {
      newValue: this.value,
      showColorPicker: true
    }
  },
  methods: {
    currentProperties: function () {
      const properties = {}

      if(this.field.readonly) {
        this.showColorPicker = false;
      }

      return properties
    }
  },
  watch: {
    newValue (val) { // Updates v-model on the parent
      if(val.hex){
        this.newValue = val.hex;
        this.$emit('input', val.hex)
      } else if(val){
        this.newValue = val;
        this.$emit('input', val)
      }
    }
  }
};
</script>
